import { render, staticRenderFns } from "./CategoriaFormulario.vue?vue&type=template&id=68b37778"
import script from "./CategoriaFormulario.vue?vue&type=script&lang=js"
export * from "./CategoriaFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports